module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/01f3acb5f0fcb67fa2071e939e16dcc9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond3.svg
// module id = 9A8k
// module chunks = 1